export default {"src":"/_next/static/media/olea_logo.54802228.svg","height":18,"width":68,"blurWidth":0,"blurHeight":0};